/**
 * @packageDocumentation
 * @module f1/is
 */

/**
 * @packageDocumentation
 * @module f1/is
 */

/* eslint-disable @typescript-eslint/ban-types */
import { t_value } from '../types';
import to_string from '../to/to_string';

export interface IsEqualDeep {
  /**
   * Are two values deep equal (recursive equality)
   *
   * @public
   * @function f1.is.equalDeep
   * @param x first value
   * @param y second value
   * @example
   *
   * ```ts
   * f1.is.equalDeep({ g: 1 }, { g: 2, h: 2 }) => false
   * f1.is.equalDeep({ g: 1 }, { g: 2 }) => true
   * f1.is.equalDeep(3, 3) => true
   * ```
   */
  (x: t_value, y: t_value): boolean;
  /**
   * @param x first value
   */
  (x: t_value): (y: t_value) => boolean;
}

/**
 * @see IsEqualDeep
 */
export default (x: t_value, y: t_value) => {
  return to_string(x) === to_string(y);
};
